module.exports = __webpack_public_path__ + "media/images/favicons/boxcoachingcorps-1ffe3d50afcc835170fc9730980f2628ed96deadb4536989bb36956384cd7282.ico";